import JSONTextEditor from "components/JSONTextEditor/JSONTextEditor";
import { useEffect, useImperativeHandle, useState, forwardRef } from "react";
import { Button } from "reactstrap";
import { useSetAtom } from "jotai";
import { objectFilter } from "atoms/GlobalAtoms";
import AppDrawer from "../Drawers/AppDrawer";

/**
 *
 * @param {*} value - The value of the object
 * @param {object} field - The field schema of the object
 * @param {function} onChange - Callback function for when the object is changed
 * @param {boolean} disabled - Whether or not the object is disabled
 * @param {function} onOpen - Callback function for when the object is opened
 * @param {function} onClose - Callback function for when the object is closed
 * @param {boolean} filter - Whether or not the object is filtered
 */

const ObjectCreate = (
  { value, field, onChange, disabled, onOpen, onClose, filter = false },
  ref
) => {
  const [open, setOpen] = useState(false);
  const [readable, setReadable] = useState("");
  const [val, setVal] = useState(null);
  const [rawVal, setRaw] = useState(JSON.parse(JSON.stringify(value)));
  const [formatCount, setFormatCount] = useState(0);
  const setFilter = useSetAtom(objectFilter);

  useEffect(() => {
    if (rawVal) {
      setReadable("Click to edit");
    }
  }, [rawVal]);

  const isValidObject = (theVal) =>
    theVal && theVal !== "Failed" && typeof theVal === "object";

  const handleEditorChange = (newValue) => {
    if (isValidObject(newValue)) setRaw(newValue);
    setVal(newValue);
  };

  const handleCancel = () => {
    setVal(value ?? null);
    setOpen(false);
    if (filter) {
      setFilter(false);
    }
  };

  const handleFormat = () => setFormatCount((prev) => prev + 1);

  const handleSave = () => {
    if (isValidObject(val)) {
      onChange(field, val);
      setOpen(false);
      setVal(val);
    }
    if (filter) {
      setFilter(false);
    }
  };

  useImperativeHandle(ref, () => ({
    focus: () => setOpen(true),
  }));

  return (
    <>
      <div
        style={{
          height: "calc( 0.45em + 1.25rem + 5px)",
          borderRadius: "0.25rem",
          fontSize: "0.875rem",
          lineHeight: 1.5,
          padding: "0.25rem 0.5rem",
          overflowY: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          background: disabled ? "#c6cac7" : "unset",
          cursor: disabled ? "not-allowed" : "pointer",
        }}
        className="border"
        onClick={
          disabled
            ? null
            : () => {
                setOpen(true);
                if (filter) {
                  setFilter(true);
                }
              }
        }
      >
        {readable || <>--</>}
      </div>
      <AppDrawer
        open={open}
        onClose={handleCancel}
        headerTitle={field.Name}
        body={
          <>
            <JSONTextEditor
              existingObject={rawVal}
              onChange={handleEditorChange}
              format={formatCount}
            />
            <div className="d-flex justify-content-between pt-3">
              <div>
                <Button
                  color="info"
                  onClick={handleFormat}
                  disabled={!isValidObject(val)}
                >
                  Format
                </Button>
              </div>
              <div>
                <Button
                  color="primary"
                  onClick={handleSave}
                  disabled={!isValidObject(val)}
                >
                  Save
                </Button>
              </div>
            </div>
          </>
        }
      />
    </>
  );
};

export default forwardRef(ObjectCreate);
